import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    admin: false,
    roles: [], //角色列表
    currentRole: {}, //当前角色
    permission: [],
    dynamicPerm: {},
  },
  getters: {
    admin: (state) => state.admin,
    roles: (state) => state.roles,
    currentRole: (state) => state.currentRole,
    permission: (state) => state.permission,
    dynamicPerm: (state) => state.dynamicPerm,
  },
  mutations: {
    setAdmin(state, admin) {
      state.admin = admin;
    },
    setRoles(state, roles) {
      state.roles = roles;
    },
    setCurrentRole(state, currentRole) {
      state.currentRole = currentRole;
    },
    setPermission(state, permission) {
      state.permission = permission;
    },
    setDynamicPerm(state, dynamicPerm) {
      state.dynamicPerm = dynamicPerm;
    },
  },
  actions: {
    setAdmin({ commit }, admin) {
      commit("setAdmin", admin);
    },
    setRoles({ commit }, role) {
      commit("setRoles", role);
    },
    setCurrentRole({ commit }, role) {
      commit("setCurrentRole", role);
    },
    setPermission({ commit }, permission) {
      commit("setPermission", permission);
    },
    setDynamicPerm({ commit }, dynamicPerm) {
      commit("setDynamicPerm", dynamicPerm);
    },
  },
};
